import "intl"
import "intl/locale-data/jsonp/en"
import "react-native-gesture-handler"
import "react-native-match-media-polyfill"

import { NavigationContainer } from "@react-navigation/native"
import { createStackNavigator } from "@react-navigation/stack"
import { useFonts } from "@use-expo/font"
import React from "react"
import { StatusBar, View } from "react-native"
import FlashMessage from "react-native-flash-message"
import { Host } from "react-native-portalize"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"

import Base, { Store } from "./base"
import RootScreen from "./views/root/RootScreen"
import WebViewScreen from "./views/root/WebviewScreen"
import MenuDetailScreen from "./views/settings/menu/detail/MenuDetailScreen"
import MenuScreen from "./views/settings/menu/toplevel/MenuScreen"
import SettingsScreen from "./views/settings/SettingsScreen"

// Needed to prevent text cut-off on a lot of android devices
Base.functions.androidFontFix()

let persistor = persistStore(Store)
// Uncomment below to clear app storage on every launch
// persistor.purge();

const RootStack = createStackNavigator()
const MainStack = createStackNavigator()
function MainStackScreen() {
  return (
    <Host>
      <MainStack.Navigator screenOptions={{ cardStyle: { flex: 1 } }}>
        <MainStack.Screen name="Root" component={RootScreen} />
        <MainStack.Screen name="Settings" component={SettingsScreen} />
        <MainStack.Screen name="Menu" component={MenuScreen} />
        <MainStack.Screen name="MenuDetails" component={MenuDetailScreen} />
      </MainStack.Navigator>
    </Host>
  )
}

export default function App() {
  let fontsLoaded = useFonts({
    "OpenSans-Light": require("./assets/fonts/OpenSans-Light.ttf"),
    "OpenSans-Regular": require("./assets/fonts/OpenSans-Regular.ttf"),
    "OpenSans-Bold": require("./assets/fonts/OpenSans-Bold.ttf"),
    "OpenSans-SemiBold": require("./assets/fonts/OpenSans-SemiBold.ttf"),
    "OpenSans-ExtraBold": require("./assets/fonts/OpenSans-ExtraBold.ttf"),
  })

  if (!fontsLoaded) {
    return <View />
  }

  return (
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <NavigationContainer>
          <StatusBar
            barStyle="light-content"
            backgroundColor={Base.colours.appDarkYellow}
          />
          <RootStack.Navigator mode="modal">
            <RootStack.Screen
              name="main"
              component={MainStackScreen}
              options={{ headerShown: false }}
            />
            <RootStack.Screen name="webview" component={WebViewScreen} />
          </RootStack.Navigator>
        </NavigationContainer>
        <FlashMessage position="top" />
      </PersistGate>
    </Provider>
  )
}
